/**
 * WebContainer — Centers content with a max-width constraint.
 * On mobile screens, maxWidth is wider than the viewport so it's effectively full-width.
 * No Platform.OS checks needed — plain maxWidth + alignSelf works everywhere.
 */

import React from 'react';
import { View, type ViewStyle, type ViewProps } from 'react-native';

type Variant = 'page' | 'content' | 'exercise' | 'chat';

const MAX_WIDTHS: Record<Variant, number> = {
  page: 896,
  content: 768,
  exercise: 576,
  chat: 672,
};

interface WebContainerProps extends ViewProps {
  variant?: Variant;
  children: React.ReactNode;
}

export function WebContainer({
  variant = 'page',
  children,
  style,
  ...props
}: WebContainerProps) {
  const containerStyle: ViewStyle = {
    width: '100%',
    maxWidth: MAX_WIDTHS[variant],
    alignSelf: 'center',
  };

  return (
    <View style={[containerStyle, style]} {...props}>
      {children}
    </View>
  );
}
